import { useState } from "react"
import { User } from "firebase/auth"
import { updateUserProfile } from "../../services/auth"
import toast from "react-hot-toast"

interface NameConfirmationModalProps {
  user: User
  onComplete: () => void
}

const NameConfirmationModal: React.FC<NameConfirmationModalProps> = ({
  user,
  onComplete,
}) => {
  const [displayName, setDisplayName] = useState(user.displayName || "")
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      await updateUserProfile(user, displayName)
      toast.success("Profile updated successfully!")
      onComplete()
    } catch (error) {
      toast.error("Failed to update profile. Please try again.")
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
        <h2 className="text-2xl font-bold mb-4">Confirm Your Name</h2>
        <p className="text-gray-600 mb-6">
          Please confirm or update your display name before continuing.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="displayName"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Display Name
            </label>
            <input
              type="text"
              id="displayName"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-primary-700 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? "Updating..." : "Confirm & Continue"}
          </button>
        </form>
      </div>
    </div>
  )
}

export default NameConfirmationModal 